<!-- Video controls - conditional visibility based on device and state -->
<div (click)="onControlsTouch($event)"
     (touchstart)="onControlsTouch($event)"
     [class.opacity-0]="!shouldShowControls()"
     [class.opacity-100]="shouldShowControls()"
     [class.pointer-events-auto]="shouldShowControls()"
     [class.pointer-events-none]="!shouldShowControls()"
     class="video-controls-overlay z-[60] transition-opacity duration-300">
  <!-- Video Progress Bar -->
  <div (click)="onProgressContainerClick($event)"
       (touchend)="onProgressTouchEnd($event)"
       (touchstart)="onProgressTouchStart($event)"
       class="video-progress-container">
    <div class="video-progress-track">
      <div
          [style.width.%]="progressPercentage"
          class="video-progress-fill">
      </div>
    </div>
  </div>
  <!-- Video Control Buttons -->
  <div class="video-controls-bottom">
    <!-- Play/Pause Button -->
    <button
        (click)="togglePlayPause.emit()"
        aria-label="Toggle video play/pause"
        class="video-control-btn video-play-pause">
      @if (isPaused) {
        <svg fill="none" height="20" viewBox="0 0 24 24" width="20">
          <path d="M8 5v14l11-7z" fill="currentColor" stroke="currentColor" stroke-width="2"/>
        </svg>
      } @else {
        <svg fill="none" height="20" viewBox="0 0 24 24" width="20">
          <path d="M6 4h4v16H6zM14 4h4v16h-4z" fill="currentColor" stroke="currentColor" stroke-width="2"/>
        </svg>
      }
    </button>
    <!-- Volume Controls -->
    <div class="video-volume-controls">
      <button
          (click)="toggleMute.emit()"
          aria-label="Toggle video mute"
          class="video-control-btn video-mute">
        @if (isMuted) {
          <svg fill="none" height="18" viewBox="0 0 24 24" width="18">
            <path d="M11 5L6 9H2v6h4l5 4V5zM22 9l-6 6M16 9l6 6" stroke="currentColor" stroke-width="2"/>
          </svg>
        } @else {
          <svg fill="none" height="18" viewBox="0 0 24 24" width="18">
            <path d="M11 5L6 9H2v6h4l5 4V5zM19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"
                  stroke="currentColor" stroke-width="2"/>
          </svg>
        }
      </button>
      <!-- Custom Volume Slider with Visual Fill -->
      <div (click)="onVolumeSliderClick($event)" class="video-volume-slider-container">
        <div class="video-volume-track">
          <div [style.width.%]="displayVolume * 100" class="video-volume-fill">
            <div class="video-volume-thumb"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- Time Display -->
    <div class="video-time-display">
      {{ currentTime }} / {{ duration }}
    </div>
  </div>
</div>
